/*
 * @Author: renjie
 * @description：  权益相关 路由
 */
const route = [
  {
    path: '/hospital/promotion/taiping/traffic',
    name: 'taipingTraffic',
    component: () => import(/* webpackPrefetchPlaceHolder */ './taiping/traffic'),
    exact: true,
    title: '免费领100万交通意外保障',
  },
  {
    path: '/hospital/promotion/taiping/medical',
    name: 'taipingMedical',
    component: () => import(/* webpackPrefetchPlaceHolder */ './taiping/medical'),
    exact: true,
    title: '免费领100万住院保障',
  },
  {
    path: '/hospital/promotion/taiping/success',
    name: 'taipingSuccess',
    component: () => import(/* webpackPrefetchPlaceHolder */ './taiping/success'),
    exact: true,
    title: '领取成功',
  },
];
export default route;

